export  const  Role = {
    ROLE_USER: 'ROLE_USER',
    ROLE_MERCHANT: 'ROLE_MERCHANT',
    ROLE_DEVELOPER: 'ROLE_DEVELOPER',
}
